// /lib/samantha/express-actions.ts

export type SamanthaExpressAction = {
  id: string
  label: string
  icon: 'sparkles' | 'pen' | 'users' | 'funnel' | 'crm' | 'course' | 'rocket'
  prompt: string
  routes?: string[]
  match?: 'exact' | 'startsWith'
  requiresOwner?: boolean
  requiresFeature?: string
}

export const SAMANTHA_EXPRESS_ACTIONS: SamanthaExpressAction[] = [
  {
    id: 'create-content',
    label: 'Crear contenido',
    icon: 'pen',
    prompt: 'Quiero crear una publicación',
    routes: ['*'],
  },
  {
    id: 'continue-onboarding',
    label: 'Continuar onboarding',
    icon: 'rocket',
    prompt: 'Continuar onboarding',
    routes: ['/home'],
    match: 'exact',
  },
  {
    id: 'create-funnel',
    label: 'Crear embudo',
    icon: 'funnel',
    prompt: 'Quiero crear un embudo',
    routes: ['/', '/home', '/onboarding', '/funnel-builder'],
    match: 'exact',
  },
  {
    id: 'promote-funnel',
    label: 'Promover embudo',
    icon: 'rocket',
    prompt: 'Quiero promover este embudo',
    routes: ['/funnel-builder'],
    match: 'startsWith',
    requiresOwner: true,
  },
  {
    id: 'launchpad-create-funnel',
    label: 'Crear embudo',
    icon: 'funnel',
    prompt: 'Quiero crear un embudo nuevo',
    routes: ['/launchpad'],
    match: 'exact',
    },
    {
    id: 'launchpad-whatsapp-sequence',
    label: 'Crear secuencia de WhatsApp',
    icon: 'crm',
    prompt: 'Quiero crear una secuencia de WhatsApp',
    routes: ['/launchpad'],
    match: 'exact',
    },
    {
    id: 'launchpad-create-content',
    label: 'Crear contenido',
    icon: 'pen',
    prompt: 'Quiero crear contenido para redes',
    routes: ['/launchpad'],
    match: 'exact',
    },
    {
    id: 'launchpad-diagnosis',
    label: 'No sé por dónde empezar',
    icon: 'sparkles',
    prompt:
        'No sé por dónde empezar. Hazme un diagnóstico rápido y dime mi siguiente mejor acción.',
    routes: ['/launchpad'],
    match: 'exact',
    },
  {
    id: 'community-post',
    label: 'Publicar en comunidad',
    icon: 'users',
    prompt: 'Quiero crear una publicación para mi comunidad',
    routes: ['/community_not'],
    match: 'exact',
  },
  {
    id: 'summarize-community',
    label: 'Resumir comunidad',
    icon: 'sparkles',
    prompt: 'Resume la actividad reciente de mi comunidad',
    routes: ['/community_not'],
    match: 'exact',
  },
  {
    id: 'create-course',
    label: 'Crear curso',
    icon: 'course',
    prompt: 'Quiero crear un curso',
    routes: ['/courses', '/academy'],
    match: 'startsWith',
    requiresOwner: true,
  },
  {
    id: 'create-crm-sequence',
    label: 'Crear secuencia',
    icon: 'crm',
    prompt: 'Quiero crear una secuencia de WhatsApp',
    routes: ['/crm', '/whatsapp-crm'],
    match: 'startsWith',
    requiresOwner: true,
  },
]

export function getSamanthaExpressActions(input: {
  pathname: string
  isOwner?: boolean
  features?: Record<string, any> | null
}) {
  const { pathname, isOwner, features } = input

  const isLaunchpad = pathname === '/launchpad'

  return SAMANTHA_EXPRESS_ACTIONS.filter((action) => {
    if (action.requiresOwner && !isOwner) return false

    if (action.requiresFeature) {
      const value = features?.[action.requiresFeature]
      if (!value) return false
    }

    if (!action.routes?.length) return !isLaunchpad
    if (action.routes.includes('*')) return !isLaunchpad

    return action.routes.some((route) => {
      if (action.match === 'startsWith') {
        return pathname.startsWith(route)
      }

      return pathname === route
    })
  }).slice(0, isLaunchpad ? 4 : 4)
}